import {BasicReducerState, initialReducerState} from "../BasicReducerState";
import {Customer} from "../../models/customers/Customer";
import {Nullable} from "../../models/common/Nullable";
import {
    CREATE_CUSTOMER, CREATE_CUSTOMER_ERROR, CREATE_CUSTOMER_SUCCESS,
    CustomerActionTypes,
    DELETE_CUSTOMER, DELETE_CUSTOMER_ERROR, DELETE_CUSTOMER_SUCCESS,
    FETCH_CUSTOMER_BY_ID,
    FETCH_CUSTOMER_BY_ID_ERROR,
    FETCH_CUSTOMER_BY_ID_SUCCESS,
    FETCH_CUSTOMERS,
    FETCH_CUSTOMERS_ERROR,
    FETCH_CUSTOMERS_SUCCESS, RESTORE_CUSTOMER, RESTORE_CUSTOMER_ERROR, RESTORE_CUSTOMER_SUCCESS,
    UPDATE_CUSTOMER, UPDATE_CUSTOMER_ERROR, UPDATE_CUSTOMER_SUCCESS
} from "../../actions/customers/CustomerActions";

import {
    errorFetchingRequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";


export interface CustomerState extends BasicReducerState<Nullable< Customer[] >, Nullable< Customer >> {

}

const initialState: CustomerState = initialReducerState();

export function CustomerReducer(
    state: CustomerState = initialState,
    action: CustomerActionTypes
) {
    
    switch( action.type ) {
        case FETCH_CUSTOMERS:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: startFetchingRequestState()
                },
            };
        case FETCH_CUSTOMERS_SUCCESS:
            return {
                ...state,
                totalEntries: action.payload.totalEntries,
                entries: {
                    current: action.payload.entries,
                    request: successFetchingRequestState()
                }
            };
        case FETCH_CUSTOMERS_ERROR:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: errorFetchingRequestState( action.error )
                }
            };
        case FETCH_CUSTOMER_BY_ID:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.customerId.rawValue ]: {
                        entry: null,
                        request: startFetchingRequestState()
                    }
                }
            };
        case FETCH_CUSTOMER_BY_ID_SUCCESS:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.customer.customerId.rawValue ]: {
                        entry: action.customer,
                        request: successFetchingRequestState()
                    }
                }
            };
        case FETCH_CUSTOMER_BY_ID_ERROR:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.customerId.rawValue ]: {
                        ...state.detailedEntries[ action.customerId.rawValue ],
                        request: errorFetchingRequestState( action.error )
                    }
                }
            };
        case CREATE_CUSTOMER:
        case UPDATE_CUSTOMER:
        case DELETE_CUSTOMER:
        case RESTORE_CUSTOMER:
            return {
                ...state,
                changingRequest: startFetchingRequestState()
            };
        case CREATE_CUSTOMER_SUCCESS:
        case UPDATE_CUSTOMER_SUCCESS:
        case DELETE_CUSTOMER_SUCCESS:
        case RESTORE_CUSTOMER_SUCCESS:
            return {
                ...state,
                changingRequest: successFetchingRequestState()
            };
        case CREATE_CUSTOMER_ERROR:
        case UPDATE_CUSTOMER_ERROR:
        case DELETE_CUSTOMER_ERROR:
        case RESTORE_CUSTOMER_ERROR:
            return {
                ...state,
                changingRequest: errorFetchingRequestState( action.error )
            };
        
        default: 
            return state;
    }
    
}